module.exports = __webpack_public_path__ + "assets/img/98aaca37ee083181aa25bebe0768b0b9.png";